import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icn-exist-stock.png'
import _imports_1 from '@/assets/images/icn-favorites-folder-menu.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-53bafd9c")

_pushScopeId("data-v-53bafd9c")
const _hoisted_1 = { class: "shopping-ingredient-list-item" }
const _hoisted_2 = { class: "shopping-ingredient-list-item-check-image" }
const _hoisted_3 = { class: "shopping-ingredient-list-item-name" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "shopping-ingredient-list-item-stock-image"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "shopping-ingredient-list-item-spacer" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "shopping-ingredient-list-item-select-image",
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "shopping-ingredient-list-item-check",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tappedCheck(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          class: "shopping-ingredient-list-item-check-image-image",
          src: _ctx.getCheckImage()
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "commonTextBodyStrong shopping-ingredient-list-item-name-text",
        style: _ctx.textDecoration
      }, _toDisplayString(_ctx.ingredientName), 5)
    ]),
    _createVNode("div", {
      class: "shopping-ingredient-list-item-stock",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.tappedStock(...args)))
    }, [
      (_ctx.hasStock)
        ? (_openBlock(), _createBlock("img", _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    _createVNode("div", {
      class: "shopping-ingredient-list-item-select",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.tappedEdit(...args)))
    }, [
      (!_ctx.check)
        ? (_openBlock(), _createBlock("img", _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
})